import React from 'react';
import HeroSection from '../components/HeroSection';
import EventsSection from '../components/EventsSection';
import TshirtSection from '../components/TshirtSection';
import FacebookFeedSection from '../components/FacebookFeedSection';
import SponsorsSection from '../components/SponsorsSection';

const Home: React.FC = () => {
  return (
    <main>
      <HeroSection />
      <section className="bg-[#f7f8fa] py-20">
        <div className="page-container">
          <div className="grid items-start gap-12 lg:grid-cols-[minmax(0,0.8fr)_minmax(0,1.2fr)]">
            <div>
              <FacebookFeedSection />
            </div>
            <div>
              <SponsorsSection />
            </div>
          </div>
        </div>
      </section>
      <EventsSection />
      <TshirtSection />
    </main>
  );
};

export default Home;
